import { apiClient } from '../services/apiService';
import { API_ROOT } from './constants';

export const fetchExcelData = (
  plantUnitKey,
  callbackProgress,
  callbackOk,
  callbackError
) => {
  callbackProgress();
  return new Promise((resolve, reject) => {
    apiClient
      .post(`${API_ROOT}/taxonomytoexcel`, plantUnitKey)
      .then((res) => {
        resolve(res.data);
        callbackOk();
      })
      .catch((err) => {
        callbackError();
        console.error(err);
      });
  });
};

export const fetchExcelEditedData = (
  callbackProgress,
  callbackOk,
  callbackError
) => {
  callbackProgress();
  return new Promise((resolve, reject) => {
    apiClient
      .get(`${API_ROOT}/taxonomyEditedtoexcel`)
      .then((res) => {
        resolve(res.data);
        callbackOk();
      })
      .catch((err) => {
        callbackError();
        console.error(err);
      });
  });
};
